import { render, staticRenderFns } from "./store-page.vue?vue&type=template&id=a7a6489e&scoped=true"
import script from "./store-page.vue?vue&type=script&lang=js"
export * from "./store-page.vue?vue&type=script&lang=js"
import style0 from "./store-page.vue?vue&type=style&index=0&id=a7a6489e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a6489e",
  null
  
)

export default component.exports